var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-92df0b7a\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Imprint.de.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/i18n/views/Imprint.de.vue
// module id = 437
// module chunks = 0